import { Component, ElementRef, inject, OnInit, Renderer2, ViewChild } from "@angular/core";
import { isActive, Router } from "@angular/router";
import { environment } from "@app/../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { ClickarPath, Permission, SessionKey } from "@shared/clickar-constants";
import { UserDTO } from "@shared/model/user.model";
import { ApiService } from "@shared/services/api.service";
import { StorageManagerService } from "@shared/services/storage/storage-manager.service";
import { UsersService } from "@shared/services/users/users.service";
import { WcmService } from "@shared/services/wcm/wcm.service";
import { OAuthService } from "angular-oauth2-oidc";
import { take } from "rxjs/operators";
@Component({
	selector: "app-private-header",
	templateUrl: "./private-header.component.html",
	styleUrl: "./private-header.component.scss",
	standalone: false
})
export class PrivateHeaderComponent implements OnInit {
	@ViewChild('hamburgerBtn', { static: true }) hamburgerBtn!: ElementRef;
	protected ClickarPath = ClickarPath;
	protected environment = environment;
	private router = inject(Router);
	// private ngZone = inject(NgZone);
	private renderer = inject(Renderer2);

	managementOpen = false;
	profileOpen = false;

	partner = true;
	showcaseEnabled = false;
	private oauthService: OAuthService = inject(OAuthService);

	protected market = "";

	purchaseOpen = false;

	get PERMISSION() {
		return Permission;
	}

	openMenu = (menu: "management" | "profile" | "purchase") => {
		this.closeMenus();
		switch (menu) {
			case 'management':
				this.managementOpen = true;
				break;
			case 'profile':
				this.profileOpen = true;
				break;
			case 'purchase':
				this.purchaseOpen = true;
				break;
		}
	};

	closeMenus = () => {
		this.managementOpen = this.profileOpen = this.purchaseOpen = false;
	};

	/** Tells whether we are on an auction-details page */
	readonly isAuctionActive = isActive(`/${ClickarPath.PRIVATE}/${ClickarPath.AUCTION_DETAILS}`, this.router, {
		paths: "exact",
		queryParams: "ignored",
		fragment: "ignored",
		matrixParams: "ignored"
	});

	user: UserDTO;

	langs: string[] = [];

	currentLang: string;
	isAdmin: boolean;
	isCustomerCenter: boolean;

	constructor(
		public translate: TranslateService,
		private storageService: StorageManagerService,
		protected wcmService: WcmService,
		private userService: UsersService,
		private apiService: ApiService
	) {
		// this.showHideProfile = false;
		// this.iconClass = "";
		this.langs = translate.getLangs().slice(0);
		this.currentLang = translate.getCurrentLang();
		this.userService.getProfileOfLoggedUser()
			.pipe(take(1))
			.subscribe(user => {
				this.market = user.idMarket;
			});
	}
	hamburgerOpen = false;

	ngOnInit(): void {
		if (!this.currentLang && this.storageService.hasSessionItem(SessionKey.USER_LANGUAGE)) {
			const language: string = this.storageService.getSessionItem(
				SessionKey.USER_LANGUAGE,
				"en"
			).toLowerCase();

			// this.market = this.storageService.getSessionItem(SessionKey.USER_MARKET, "IT").toUpperCase();

			// console.log("app component language session", language);
			this.translate.use(`${language}-${this.market}`);

			// console.log(`>>>>>> ${language}-${this.market}`);
			this.currentLang = this.translate.getCurrentLang();
		}

		this.userService.getProfileOfLoggedUser().pipe(take(1)).subscribe(value => {
			this.user = value;
			this.refreshLang(value.preferredLanguage.toLowerCase(), value.idMarket.toUpperCase());
		});

		this.userService.isAdmin().subscribe(value => {
			this.isAdmin = value;
		});

		this.userService.isCustomerCenter().subscribe(value => {
			this.isCustomerCenter = value;
		});

		this.apiService.isShowcaseOpenUsingGET().subscribe(value => {
			this.showcaseEnabled = value;
		});

		this.renderer.listen( // NOTE: used this instead of (click) event cause Capacitor delays it
			this.hamburgerBtn.nativeElement,
			"click",
			() => { this.hamburgerOpen = !this.hamburgerOpen; }
		);
	}

	private refreshLang(lang: string, market: string) {
		this.langs = this.langs
			.filter(l => l.endsWith(market))
			.sort((a, b) => a.localeCompare(b));
		if (!this.langs.length) {
			this.langs = ["en-IT"];
		}
		let userLang = `${lang}-${market}`;
		if (!this.langs.includes(userLang)) {
			userLang = this.langs.find(l => l.startsWith(lang)) ?? this.langs.find(l => l.startsWith("en"));
		}
		this.translate.use(this.currentLang = userLang);

		// this.currentLang = market === "be" ? "nl" : market.toLowerCase();
	}

	hasPermission(permission: `${Permission}`): boolean {
		if (this.user) {
			return this.user.permission === permission;
		} else {
			this.userService.getProfileOfLoggedUser().subscribe(value => {
				this.user = value;
				return this.user.permission === permission;
			});
		}
	}

	changeLang(value: string) {
		if (value) {
			/* if (
				value === "nl" &&
				this.localizedCountry.toLowerCase() === "be"
			) {
				this.translate.use("nl-BE");
			} else {
				this.translate.use(value.toLowerCase() + "-" + this.user.idMarket);
			}
			this.currentLang = value;
			if (this.currentLang === "be") {
				this.currentLang = "nl";
			}
			 */
			// this.closeMenu();
			this.translate.use(value);
		}
	}

	logout() {
		this.userService.logout();
		this.storageService.setSessionItem(SessionKey.USER_LOGOUT, "true");
		if (environment.develop) {
			this.router.navigate(["/"]);
		} else {
			this.oauthService.revokeTokenAndLogout().then(() => {
				window.location.href = environment.clickarCom;
			});
		}
	}
}